<ng-container *ngIf="showAlert$ | async">
  <sms-registration-alert
    [alertType]="'warning'"
    (actionClick)="navigateToSmsConfiguration()"
    (closeClick)="dismissAlert()"
  ></sms-registration-alert>
</ng-container>
